import SentrySDK from 'common/3rd/SentrySDK';
import AJAX from 'common/AJAX';
import getCookies from 'common/getCookies';
import Message from 'common/message/Message';

const SentryDSN = '6c11faba7fb345f38e41e7daf51a053a';
const SessionIDName = '__canny__sessionID';
const UserIDName = '__canny__userID';

import 'common/Polyfills';
import 'common/storage/sessionStorageWrapper';

SentrySDK.init(SentryDSN);

const OriginAllowlist = {};

Message.subscribe(window.parent, null, 'verifyDomain', (requestData, origin) => {
  if (!origin) {
    return;
  }

  const domain = origin.replace('http://', '').replace('https://', '');
  AJAX.post(
    '/api/domains/verify',
    {
      domain,
    },
    (response) => {
      if (response !== 'success') {
        return;
      }

      OriginAllowlist[origin] = true;

      const cookies = getCookies();
      Message.postMessage(window.parent, origin, 'cannyCookies', {
        ...(cookies[UserIDName] && {
          [UserIDName]: cookies[UserIDName],
        }),
        ...(cookies[SessionIDName] && {
          [SessionIDName]: cookies[SessionIDName],
        }),
      });
    }
  );
});
